import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Header from '../Components/Header';
import Sidebar from '../Components/Sidebar/Sidebar';

const PrivateLayout = () => {
    let token = sessionStorage.getItem("token");
    let isLogin = token;
    let navigate = useNavigate();

    useEffect(() => {
      
        if (!isLogin) {
            navigate("/signin");
        }
    }, [isLogin, navigate]);

    return (
        <div>
            <Header />
            <Sidebar />
            <div>
                {isLogin ? <Outlet /> : null} 
            </div>
        </div>
    );
}

export default PrivateLayout;
